import styled from 'styled-components';
import Button from '@material-ui/core/Button';

export const ButtonDetails = styled(Button)`
  border-radius: 8px !important;
  color: #1973e8 !important;
  font-family: Montserrat !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.14 !important;
  letter-spacing: 1.5px !important;
`;

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;
